<template>
  <div
    id="somnambulist-ui"
    class="wine-club main-container"
  >
    <join v-if="showJoin"/>
    <order
      v-else
      @cancelOrder="$emit('cancelOrder')"
    />
  </div>
</template>

<script>
import Join from './components/join/Join.vue'
import Order from './components/order/Order.vue'

const blobs = [
  'somnambulist-banner',
  'somnambulist-intro'
]

function getPreloadImageUrlPromise(store, presetSets, imageSets) {
  try {
    let files = []
    let i = 0
    while (i < presetSets.length && i < imageSets.length) {
      const preset = presetSets[i] || '__original'
      const images = imageSets[i].filter(img => img && img.filepath) || []
      files = files.concat(
        images.map(img => ({ ...img, preset: preset }))
      )
      files = files.concat(
        images.map(img => ({ ...img, preset: preset + '__lowres' }))
      )
      i++
    }
    return store.dispatch('filestore/getFileURLBulk', { files, filestorename: 'website' })
  } catch {
    return []
  }
}

export default {
  components: {
    Join,
    Order,
  },
  asyncData({ store, route, router }) {
    const __loader = () => {
      applogger.debug('Somnambulist UI asyncData starting')

      if(typeof router === 'undefined')  {
        return Promise.resolve(false)
      }

      const promises = [
        store.dispatch('blob/loadgroup', {blobIDs: blobs, cacheOptions: { scope: 'global', ttl: 3600 * 12 }}),
        store.dispatch('somnambulistui/init', { loadAddresses: true }),
        store.dispatch('somnambulistui/loadCurrentGroups'),
        store.dispatch('ecommerce/init', { wait: true, txntype: 'somnambulist' })
      ]
      if (!this.$ssrRunMode) {
        const id = router.currentRoute.params.id || null
        const mode = router.currentRoute.params.mode || 'edit'
        if ( id ) {
          promises.push(
            store.dispatch('somnambulistui/loadOrder', {id})
              .then(() => {
                store.commit('somnambulistui/SET_ORDER_MODE', mode)
                if (mode !== 'edit') {
                  if (!store.state.somnambulistui.orderLocked) {
                    store.commit('somnambulistui/SET_DIRTY_FLAG', { key: 'order', value: true })
                    store.commit('somnambulistui/SET_UPDATING_ORDER', true)
                    store.commit('somnambulistui/SET_ORDER_COMPLETED', false)
                  }
                  else {
                    store.commit('somnambulistui/SET_ORDER_MODE', 'edit')
                  }
                }
              })
          )
        }
      }

      return Promise.all(promises)
        .then(() => {
          if (store.getters['blob/isHeader']('somnambulist-banner')) {
            store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
          }
          return getPreloadImageUrlPromise(
            store,
            ['wineclubteaser'],
            [
              Object.values(store.state.somnambulistui.orderTypes).map(club => (club && club.image) ? club.image : null)
            ]
          )
        })
        .then(() => {
          applogger.debug('Somnambulist UI completed')
        })
    }

    return store.dispatch('somnambulistui/clearOrderData')
      .then(_ => store.dispatch('somnambulistui/promisePool', {
        name: 'somnambulist-ui',
        resolve: __loader
      }))
  },
  created () {
    const id = this.$router.currentRoute.params.id || null;
    const mode = this.$router.currentRoute.params.mode || 'edit';
    const groupId = this.$router.currentRoute.params.groupId || null;
    if ( id ) {
      this.$store.dispatch('somnambulistui/loadOrder', {id})
        .then(() => {
          this.$store.commit('somnambulistui/SET_ORDER_MODE', mode)
          if (mode !== 'edit') {
            if (!this.$store.state.somnambulistui.orderLocked) {
              this.$store.commit('somnambulistui/SET_DIRTY_FLAG', { key: 'order', value: true })
              this.$store.commit('somnambulistui/SET_UPDATING_ORDER', true)
              this.$store.commit('somnambulistui/SET_ORDER_COMPLETED', false)
            }
            else {
              this.$store.commit('somnambulistui/SET_ORDER_MODE', 'edit')
            }
          }
        })
      this.$store.commit('somnambulistui/SET_SCROLL_TOP', true)
      this.$store.commit('somnambulistui/SET_ORDER_MODE', mode)
    }
    else if (groupId) {
      this.$store.dispatch('somnambulistui/preselectGroup', {groupId})
      this.$store.commit('somnambulistui/SET_SCROLL_BOTTOM', true)
    }
    if (this.$store.state.somnambulistui.orderCancelled) {
      this.$store.commit('SET_PAGE_SETTING', {key: 'error', value: 404 })
    }
  },
  computed: {
    showJoin() {
      return this.$store.state.somnambulistui.orderCompleted && (
        this.$store.getters['user/isLoggedIn'] &&
        this.$store.getters['somnambulistui/initUid'] !== 0
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.main-container {
  background: var(--main-section-background-color);
  z-index: 1;
  // override torsten
  ::v-deep .form-control {
    margin-bottom: 0px !important;
  }
}
</style>
